import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import logo from "../images/catalyst/logo.png";
import LinkCard from "../components/catalyst/LinkCard";
import faci from "../data/catalyst-sugarcubes-faci.json";
import oc from "../data/catalyst-sugarcubes-oc.json";
import dels from "../data/catalyst-sugarcubes-delegates.json";

const Catalyst = () => {
  const styles = {
    blackbg: {
      backgroundColor: "#121212",
    },
    blueText: {
      color: "#037ef3",
    },
    hidden: {
      visibility: "hidden",
    },
  };

  // create list of oc sugarcubes
  const ocSugarCubes = oc.map((person) => (
    <LinkCard
      title={person["name"]}
      color="#037ef3"
      newTab={true}
      key={person["name"]}
      link={person["link"]}
    />
  ));

  // create list of faci sugarcubes
  const faciSugarCubes = faci.map((person) => (
    <LinkCard
      title={person["name"]}
      color="#037ef3"
      newTab={true}
      key={person["name"]}
      link={person["link"]}
    />
  ));

  // create list of dels sugarcubes
  const delsSugarCubes = dels.map((person) => (
    <LinkCard
      title={person["name"]}
      color="#037ef3"
      newTab={true}
      key={person["name"]}
      link={person["link"]}
    />
  ));

  const logoRef = useRef(null);
  const titleRef = useRef(null);

  const spinLogo = (e) => {
    gsap.fromTo(
      "#catalyst-logo",
      {
        rotate: "0",
      },
      {
        rotate: "-360",
        duration: 2,
        ease: "expo.inOut",
      }
    );

    gsap.fromTo(
      "#catalyst-logo",
      1,
      {
        scale: 1,
      },
      {
        scale: 1.1,
        yoyo: true,
        repeat: 1,
        duration: 1,
        ease: "expo.in",
      },
      "<"
    );
  };

  useEffect(() => {
    gsap.set(".link-card", {
      autoAlpha: 0,
      y: 40,
    });

    gsap.set(".sc-title", {
      autoAlpha: 0,
      y: 60,
    });

    let t1 = gsap.timeline({ repeat: 0 });

    t1.from(logoRef.current, {
      rotate: 100,
      ease: "expo.inOut",
      autoAlpha: 0,
      scale: 0.5,
      y: 100,
      duration: 2,
    });

    t1.from(
      titleRef.current,
      {
        ease: "expo.inOut",
        autoAlpha: 0,
        y: 80,
        duration: 2,
      },
      "<"
    );

    t1.to(
      ".sc-title",
      {
        y: 0,
        ease: "expo.out",
        scale: 1,
        autoAlpha: 1,
        duration: 1,
        delay: 1,
      },
      "<"
    );

    t1.to(".link-card", {
      y: 0,
      ease: "expo.inOut",
      scale: 1,
      autoAlpha: 1,
      duration: 1.5,
      delay: -1.8,
      stagger: 0.1,
    });

    gsap.fromTo(
      ".heart",
      0.4,
      {
        scale: 1,
      },
      {
        scale: 1.2,
        yoyo: true,
        repeat: -1,
        duration: 0.4,
        ease: "expo.in",
      },
      "<"
    );
  }, []);

  return (
    <div className="w-full min-h-screen text-white pb-8" style={styles.blackbg}>
      <div className="w-full flex flex-col justify-center items-center pt-10">
        <img
          src={logo}
          alt="catalyst-logo"
          ref={logoRef}
          id="catalyst-logo"
          className="w-20 el"
          style={styles.hidden}
          onClick={(e) => spinLogo(e)}
        />
        <div
          className="mt-4 text-5xl"
          ref={titleRef}
          style={{ ...styles.hidden, fontFamily: "catalyst" }}
        >
          CATALYST 2021
        </div>

        <div
          className="my-2 text-3xl font-thin sc-title text-center"
          style={{ color: "#037ef3" }}
        >
          Sugar Cubes
          <div className="heart">❤️</div>
        </div>
      </div>

      <div className="w-full max-w-md m-auto mt-4 mb-10 px-4">
        <div className="link-card">
          <div className="mt-4 text-2xl">OC</div>
          {ocSugarCubes}

          <div className="mt-12 text-2xl">Faci</div>
          {faciSugarCubes}

          <div className="mt-12 text-2xl">Delegates</div>
          {delsSugarCubes}
        </div>
      </div>
    </div>
  );
};

export default Catalyst;
